import { C } from "../../shared/theme";
import { goalColorTokens } from "../../shared/goalColors";
import { EditButton } from "../../shared/EditButton";
import { STATEMENT_KINDS, statementText } from "./statementKinds";

// One statement: its words (tap to show or hide its goals), Edit, and the ⠿ handle. Its goals show as
// pills that open the goal.
export function StatementRow({ kind, statement, goals, open, onToggle, onEdit, onOpenGoal, handle }) {
  const k = STATEMENT_KINDS[kind];
  const text = statementText(kind, statement);
  const linked = (statement.goalIds || []).map(id => goals.find(g => g.id === id)).filter(Boolean);
  return (
    <div style={{ padding: "4px 4px 4px 14px" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
        <button onClick={onToggle} aria-expanded={open} aria-describedby={`goals-hint-${kind}`}
          style={{ flex: 1, minWidth: 0, minHeight: 44, padding: "10px 0", textAlign: "left", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 16, fontWeight: 600, lineHeight: 1.45, color: C.text }}>
          {text}
        </button>
        <EditButton label={`Edit ${k.one}: ${text}`} onClick={onEdit} />
        {handle}
      </div>
      {open && (
        linked.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, padding: "2px 10px 10px 0" }}>
            {linked.map(goal => {
              const tok = goalColorTokens(goal.color);
              return (
                <button key={goal.id} onClick={() => onOpenGoal(goal)}
                  style={{ minHeight: 44, display: "inline-flex", alignItems: "center", gap: 6, fontSize: 14, fontWeight: 600, lineHeight: 1.3, color: C.text, background: tok.bg, border: `1px solid ${tok.light}`, borderRadius: 100, padding: "6px 12px", cursor: "pointer", fontFamily: "inherit", textAlign: "left" }}>
                  <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: "50%", background: tok.main, flexShrink: 0 }} />
                  {goal.title}
                </button>
              );
            })}
          </div>
        ) : (
          <p style={{ margin: 0, padding: "0 10px 12px 0", fontSize: 15, lineHeight: 1.5, color: C.textMid }}>
            No goals are linked to this {k.one} yet. Tap the pencil to link one.
          </p>
        )
      )}
    </div>
  );
}
